// extracted by mini-css-extract-plugin
module.exports = {"StoryContestWorks":"StoryContestWorks-module--StoryContestWorks--27nee"};